<template>
    <ies-form-field :field="field">
        <v-autocomplete hide-details dense outlined
            v-if="viewValue !== 'Other...'"
            v-model="viewValue"
            :items="[...new Set(items.concat(viewValue).filter(Boolean)), 'Other...']"
            autocomplete
        ></v-autocomplete>

        <v-text-field hide-details
            v-else
            v-model="newValue"
            validate-on="eager"
            :rules="[
                v => 'Other...' === v || 'Fill in this field, and press Enter when done, or press Esc to cancel'
            ]"
            autofocus
            required
            @focus="[
                newValue = '',
            ]"
            @keyup.enter="viewValue = newValue"
            @keyup.esc="viewValue = null"
        ></v-text-field>

        <input type="hidden" :name="field.fieldName" :text="field.text" :value="field.value">
    </ies-form-field>
</template>


<script>
    /**
     * Allows the selection of a list of pre-defined channel manager names from dropdown
     */
    export default {
        name: 'ies-input-channel-manager-names',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                items: [
					"UNKNOWN",
					"NONE",
					"Avantio",
					"Avirato",
					"Axis Rooms",
					"Beddy",
					"beds24",
					"Booking Expert",
					"Channex",
					"Clock",
					"Cloudbeds",
					"Cubilis",
					"D-Edge (Availpro)",
					"e-GDS",
					"Elloha",
					"Ericsoft",
					"Ermes",
					"Eviivo",
					"Ezee (ipms247)",
					"Freetobook",
					"Guestline",
					"Hotel Spider",
					"Hotel.BB",
					"Hotelrunner",
					"Innstyle",
					"Leo",
					"Nightsbridge",
					"Octorate",
					"Omnibees",
					"Orbe",
					"Phobs",
					"PrimalRes",
					"Rate Gain",
					"Rate Tiger",
					"Reseliva",
					"ReserVIT",
					"RoomBasket",
					"RoomCloud",
					"RoomRaccoon",
					"SabeeApp",
					"Simple Booking",
					"Siteminder",
					"Staah",
					"Supercontrol",
					"Synxis",
					"Travelclick",
					"Vertical Booking",
					"WuBook",
					"Yield Planet",
					"Other..."
				],
                viewValue: this.field.value === '' ? 'UNKNOWN' : this.field.value,
				newValue: this.field.value 
            }
        },

		watch: {
            newValue: function(name){
                console.log("HOTEL REVIEWERS: The newValue watch fired", name);
            },
            viewValue: function (name) {
                this.field.value = name;
            }
        }
    }
</script>

